module.exports = __webpack_public_path__ + "static/media/agenda.ec381a11.svg";